var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignMessageArchivePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.167,
    cy: 18,
    r: 18,
    fill: "#F6EDEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16699 12C8.16699 10.3431 9.51014 9 11.167 9H25.167C26.8238 9 28.167 10.3431 28.167 12C28.167 13.3062 27.3322 14.4175 26.167 14.8293V24C26.167 25.6569 24.8238 27 23.167 27H13.167C11.5101 27 10.167 25.6569 10.167 24L10.167 14.8293C9.0018 14.4175 8.16699 13.3062 8.16699 12ZM12.167 15V24C12.167 24.5523 12.6147 25 13.167 25H23.167C23.7193 25 24.167 24.5523 24.167 24V15H12.167ZM11.167 11C10.6147 11 10.167 11.4477 10.167 12C10.167 12.5523 10.6147 13 11.167 13H25.167C25.7193 13 26.167 12.5523 26.167 12C26.167 11.4477 25.7193 11 25.167 11H11.167ZM15.167 18C15.167 17.4477 15.6147 17 16.167 17H20.167C20.7193 17 21.167 17.4477 21.167 18C21.167 18.5523 20.7193 19 20.167 19H16.167C15.6147 19 15.167 18.5523 15.167 18Z",
    fill: "#9E3425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignMessageArchivePlaceholder);
export default __webpack_public_path__ + "static/media/signMessageArchivePlaceholder.eebb0a9ca6ce2e3db0dfcfccd421861a.svg";
export { ForwardRef as ReactComponent };